import { updateKeyInStore } from 'App';
import {
  DependentsStateValues,
  TDependentsChildrenRow,
  updateKey,
} from '../slice';

export const uploadFields: IBaseField<
  keyof DependentsStateValues | keyof TDependentsChildrenRow
>[] = [
  {
    type: 'upload',
    name: 'documentShowSameAddress',
    label:
      'Upload document showing you & the dependent share the same address?',
    subLabel: () => (
      <div>
        <p>
          To show both you and your child lived together at the same address or
          addresses for more than half of 2019, send either:
        </p>
        <ul>
          <li>School, medical, daycare, or social service records.</li>
          <li>
            A letter on the official letterhead from a school, medical provider,
            social service agency,
          </li>
        </ul>
        <p>
          or place of worship that shows names, common address and dates. (If
          you send a letter from a relative who provides your daycare, you MUST
          send at least one additional letter that provides proof.)
        </p>
        <p>
          <b>You may need to send more than one document</b> to show that the
          child lived with you for more than half of the year.
        </p>
      </div>
    ),
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    type: 'upload',
    name: 'provideHouseholdExpenses',
    label: 'Do you provide over 50% of the household expenses?',
    subLabel: () => (
      <div>
        <ul>
          <li>A statement of account from a child support agency.</li>
          <li>
            A statement from any government agency verifying the amount and type
            of benefits you and/or your dependent received for the year.
          </li>
          <li>
            Rental agreements or a statement showing the fair rental value of
            your residence (proof of lodging cost).
          </li>
          <li>
            Utility and repair bills (proof of household expenses) with canceled
            checks or receipts.
          </li>
          <li>
            Daycare, school, medical records or bills (proof of child's support)
            with canceled checks or receipts.
          </li>
          <li>
            Clothing bills (proof of child's support) with canceled checks or
            receipts.
          </li>
        </ul>
      </div>
    ),
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
];
